<template>
  <div id="app">
    <!-- <div id="nav">
      <router-link to="/">Home</router-link> |
      <router-link to="/about">About</router-link>
    </div> -->
    <a-locale-provider :locale="zh_CN">
      <router-view />
    </a-locale-provider>
  </div>
</template>
<script>
import zh_CN from "ant-design-vue/lib/locale-provider/zh_CN";
import moment from "moment";
import "moment/locale/zh-cn";

moment.locale("zh-cn");
export default {
  data() {
    return {
      zh_CN,
    };
  },
};
</script>
<style lang="scss">
ul,
li {
  list-style: none;
  margin: 0;
  padding: 0;
}
.page_custome_ {
  .ant-radio-group {
    transition: all 0.3s ease-out;
  }
  .ant-radio-button-wrapper:not(:first-child)::before {
    display: none;
  }
  .ant-radio-button-wrapper:first-child:last-child {
    border-radius: 0;
  }
  .ant-radio-button-wrapper {
    width: 170px;
    height: 60px;
    line-height: 60px;
    border: none;
    text-align: center;
    font-size: 20px;
    border-radius: 0;
    &:first-child {
      border: none;
      border-radius: 0;
    }
  }
  .ant-btn-primary {
    padding: 0 25px;
  }
  .ant-input-search-large {
    width: 384px;
    height: 50px;
    .ant-input-lg {
      border-radius: 25px;
      padding-left: 40px;
    }
    .ant-btn-primary {
      width: 83px;
      height: 40px;
      padding: 0;
      border-radius: 20px !important;
    }
    .ant-input-suffix {
      right: 8px !important;
    }
  }
}
// 页面隐藏upload文件
.page_hide_upload_file_list_ {
  .ant-upload-list {
    display: none;
  }
}
//表单空间水平布局
.page_fixed_form_control_wrapper_ {
  .horizontal_item_ .ant-form-item-control-wrapper {
    flex: 1;
  }
  .left8_ {
    .ant-form-item-label {
      padding-left: 10px;
    }
  }
  .ant-form-item-label {
    text-align: left;
  }
}
.horizontal_item_ {
  .ant-form-item {
    display: flex;
    .ant-form-item-control-wrapper {
      flex: 1;
    }
  }
}
#app {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  // text-align: center;
  color: #2c3e50;
  height: 100%;
  .clearfix_ {
    &::after {
      display: table;
      content: "";
      clear: both;
    }
    .f_r_ {
      float: right;
    }
    .f_l_ {
      float: left;
    }
  }
  .w1000_ {
    width: 1000px;
    margin: 0 auto;
  }
  .w1200_ {
    min-width: 1200px;
  }

  .page_ {
    font-family: PingFangSC-Regular;
    .c11_ {
      color: #ff4c1c;
    }
    .bold_ {
      font-family: PingFangSC-Semibold;
      font-weight: bold;
    }
    .ant-carousel {
      .slick-dots {
        button {
          width: 26px;
          height: 5px;
        }
      }
    }
    .page_wrap_ {
      display: flex;
      justify-content: center;
      margin: 40px 0 30px;
    }
    input {
      &::placeholder {
        font-size: 12px;
      }
    }
    .ant-form-horizontal {
      .ant-form-item {
        display: flex;
        .ant-form-item-control-wrapper {
          flex: 1;
        }
      }
    }
    .mrg_b0_ {
      margin-bottom: 0px;
    }
    .form_ {
      &.form_error_right_ {
        .ant-form-explain {
          position: absolute;
          right: -160px;
          top: 10px;
        }
      }
    }
    .pwd_form_ {
      .ant-form-explain {
        position: absolute;
        top: 12px;
        right: 8px;
      }
    }
  }
}
#nav {
  padding: 30px;
  a {
    font-weight: bold;
    color: #2c3e50;
    &.router-link-exact-active {
      color: #42b983;
    }
  }
}
.table_textc .ant-table-body th,
.table_textc .ant-table-body td {
  text-align: center;
}
.itemright .ant-calendar-picker-input {
  width: 100px;
}
.itemright .ant-calendar-picker-icon {
  display: none;
}

.banner_wrap_ .ant-carousel .custom-slick-arrow:before {
  display: none;
}
.banner_wrap_ .ant-carousel .custom-slick-arrow.slick-prev:hover {
  background: url(./assets/wxmall/prev.png) center center no-repeat;
  background-size: 27px 50px;
  opacity: 0.5;
}
.banner_wrap_ .ant-carousel .custom-slick-arrow.slick-next:hover {
  background: url(./assets/wxmall/next.png) center center no-repeat;
  background-size: 27px 50px;
  opacity: 0.5;
}

.banner_wrap_ .custom-slick-arrow.slick-arrow.slick-prev {
  width: 27px;
  height: 50px;
  left: -74px !important;
  background: url(./assets/wxmall/prev.png) center center no-repeat;
  background-size: 27px 50px;
  opacity: 1;
}
.banner_wrap_ .custom-slick-arrow.slick-arrow.slick-next {
  width: 27px;
  height: 50px;
  right: -74px !important;
  background: url(./assets/wxmall/next.png) center center no-repeat;
  background-size: 27px 50px;
  opacity: 1;
}
.banner_wrap_ .ant-carousel .slick-dots {
  padding-right: 17px;
  text-align: right;
  bottom: 24px;
}
.banner_wrap_ .ant-carousel .slick-dots li button {
  margin: 0 17px 0 0;
  background-color: rgba(255, 255, 255, 0.5);
  opacity: 1;
}
.banner_wrap_ .ant-carousel .slick-dots li.slick-active button {
  background-color: #ff6e59;
}
.itemright .ant-select {
  width: 200px;
}
// .product_section_ .product_list_ .desc_ {
//   white-space: normal !important;
// }
.product_section_ .product_list_ .price_wrap_ {
  position: absolute;
  padding: 0 29px;
  width: 100%;
  left: 0;
  right: 0;
  bottom: 24px;
  position: absolute;
  padding: 0 29px;
  width: 670px;
  left: 330px;
  right: 0;
  bottom: 14px;
  .pos_r_ {
    bottom: 9px !important;
  }
}

.table_textc .table_b table td {
  word-break: break-all;
}
.table_textc table tr th:first-child,
.table_textc table tr th:nth-child(2) {
  width: 150px;
}
.table_textc .table_b.table_nowrap tr td:nth-child(3),
.table_textc .table_b tr td:last-child {
  white-space: nowrap;
}
.table_1 table {
  border: 1px solid #e8e8e8;
  border-collapse: collapse;
}
.table_1 table tr th {
  text-align: center;
  font-weight: bold;
  padding: 10px 0;
}
.table_1 table tr td {
  text-align: center;
  padding: 10px 0;
}
.form_con.form_con1 {
  .ant-form-item-label {
    text-align: right;
  }
}
.table_nowrapg table tr th:first-child {
  width: 210px;
}
.table_nowrapg table tr td:first-child,
.table_nowrapg table tr td:nth-child(5),
.table_nowrapg table tr td:nth-child(6),
.table_nowrapg table tr td:nth-child(7) {
  white-space: nowrap;
}

//光大表单解除 flex:1影响
.changePwd_ {
  .ant-form-horizontal {
    .ant-form-item {
      justify-content: center;
      .ant-form-item-control-wrapper {
        flex: none !important;
      }
    }
  }
}
.gdMange_ {
  //光大保单管理
  //已自定义分页
  .ant-table-pagination {
    display: none !important;
  }
  .ant-table-footer {
    background: none !important;
  }
  table tr th:first-child,
  table tr th:nth-child(2) {
    width: auto;
  }
}
//对话框
.myModal_ {
  .ant-modal-header {
    text-align: center;
    background: #fe8f2d;
    .ant-modal-title {
      color: #fff;
      font-size: 11px;
      font-family: Microsoft YaHei UI;
      font-weight: 600;
    }
  }
  .ant-modal-footer {
    padding: 40px 16px;
    text-align: center;
    border-top: none;
    div {
      display: flex;
      justify-content: center;
    }
  }
  .ant-modal-close {
    display: none;
  }
  .flex_ {
    display: flex;
  }
}
.forModal_ {
  .ant-modal {
    min-width: 800px;
  }
  .ant-form-item-label {
    text-align: left;
  }
}
.product_list_ {
  .ant-list-item {
    position: relative;
    border: 1px solid #e5e5e5;
    margin-bottom: 29px;
    padding: 0;
    &:hover {
      border: 1px solid #f5692c;
    }
  }
}
.btn_upload .ant-upload-list {
  display: none;
}
.table-scroll table {
  width: auto !important;
}
.drop_ {
  .ant-select-dropdown-menu-item {
    white-space: normal !important;
  }
}
.phone_input input::-webkit-outer-spin-button,
.phone_input input::-webkit-inner-spin-button {
  -webkit-appearance: none !important;
  margin: 0;
  appearance: none !important;
}
.BJQ_ {
  .ant-form-item-label {
    width: 100px;
    white-space: unset;
    display: flex;
    align-items: center;
    padding: 0;
  }
  @media screen and (min-width: 375px) and (max-width: 575px) {
    .wid_label_ {
      .ant-form-item-label {
        width: 185px;
        white-space: unset;
      }
    }
  }

  @media screen and (min-width: 960px) {
    .ant-form-item-label {
      width: auto;
    }
  }
}
.modelContent_{
  img{
    width: 100%;
  }
}
.md_{
  .long.ant-row{
      .ant-form-item-label{
          white-space: pre-wrap;
      }
  }
  .ant-row{
      .ant-form-item-label{
          line-height:20px;
      }
  }
}
</style>
